var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNonBillableProjectIconsGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.277,
    height: 127.493,
    viewBox: "0 0 200.277 127.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8952",
    "data-name": "Group 8952",
    transform: "translate(-997.186 -166.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8951",
    "data-name": "Group 8951",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -15.973, 302.608)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1238",
    "data-name": "Rectangle 1238",
    width: 94.93,
    height: 83.702,
    rx: 10.144,
    transform: "translate(1118.248 159.112) rotate(29)",
    fill: "#0d37c9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1128.837 177.38) rotate(30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7351",
    "data-name": "Path 7351",
    d: "M18.365,29.224c0,5.638,3.753,10.224,8.365,10.224,11.093-.546,11.089-19.9,0-20.448C22.118,19,18.365,23.587,18.365,29.224Zm14.872,0c0,4.612-2.919,8.365-6.506,8.365-8.609-.384-8.606-16.348,0-16.73C30.318,20.859,33.237,24.612,33.237,29.224Z",
    transform: "translate(-0.564 -0.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7352",
    "data-name": "Path 7352",
    d: "M2,43.067A3.257,3.257,0,0,0,5.253,46.32h8.365A3.242,3.242,0,0,0,16.825,42.6H33.9a.93.93,0,1,0,0-1.859H15.888a3.272,3.272,0,0,0,0-4.647,3.266,3.266,0,0,0-2.27-5.577H7.577V16.577H44.756v9.332a.929.929,0,0,0,1.859,0V16.577a1.861,1.861,0,0,0-1.859-1.859H11.295V12.859H48.473v13.31a.93.93,0,1,0,1.859,0V12.859A1.861,1.861,0,0,0,48.473,11H11.295a1.861,1.861,0,0,0-1.859,1.859v1.859H7.577a1.861,1.861,0,0,0-1.859,1.859V30.519A3.282,3.282,0,0,0,2.984,36.1a3.272,3.272,0,0,0,0,4.647A3.24,3.24,0,0,0,2,43.067Zm1.859-9.295a1.4,1.4,0,0,1,1.394-1.394h8.365a1.394,1.394,0,0,1,0,2.788H5.253a1.4,1.4,0,0,1-1.394-1.394Zm0,4.647a1.4,1.4,0,0,1,1.394-1.394h8.365a1.394,1.394,0,1,1,0,2.788H5.253a1.4,1.4,0,0,1-1.394-1.394Zm9.759,3.253a1.394,1.394,0,1,1,0,2.789H5.253a1.394,1.394,0,1,1,0-2.789Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7353",
    "data-name": "Path 7353",
    d: "M49.154,29A11.166,11.166,0,0,0,38,40.154c.613,14.8,21.7,14.793,22.307,0A11.166,11.166,0,0,0,49.154,29Zm0,20.448a9.305,9.305,0,0,1-9.295-9.295c.51-12.331,18.081-12.327,18.589,0a9.305,9.305,0,0,1-9.295,9.295Z",
    transform: "translate(-2.539 -1.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7354",
    "data-name": "Path 7354",
    d: "M54.022,36.272a.929.929,0,0,0-1.314,0l-3.061,3.061-3.061-3.061a.929.929,0,1,0-1.314,1.314l3.061,3.061-3.061,3.061a.929.929,0,0,0,1.314,1.314l3.061-3.061,3.061,3.061a.929.929,0,1,0,1.314-1.314l-3.061-3.061,3.061-3.061A.929.929,0,0,0,54.022,36.272Z",
    transform: "translate(-3.033 -1.763)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8950",
    "data-name": "Group 8950"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1237",
    "data-name": "Rectangle 1237",
    width: 109.628,
    height: 109.628,
    rx: 10.144,
    transform: "translate(997.186 184.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8944",
    "data-name": "Group 8944",
    transform: "translate(1020.256 207.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7339",
    "data-name": "Path 7339",
    d: "M53.474,48.515c0-.022.013-.041.013-.062V4.965A2.965,2.965,0,0,0,50.522,2H12.965A2.965,2.965,0,0,0,10,4.965V58.336A2.965,2.965,0,0,0,12.965,61.3H40.639a.993.993,0,0,0,.7-.29L53.2,49.151a.988.988,0,0,0,.2-.29c.014-.031.022-.061.033-.093A.934.934,0,0,0,53.474,48.515Zm-41.5,9.821V4.965a.988.988,0,0,1,.988-.988H50.522a.988.988,0,0,1,.988.988v42.5h-8.9a2.965,2.965,0,0,0-2.965,2.965v8.9H12.965A.988.988,0,0,1,11.977,58.336Zm29.65-.409v-7.5a.988.988,0,0,1,.988-.988h7.5Z",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7340",
    "data-name": "Path 7340",
    d: "M30.825,12.942H46.639a.988.988,0,1,0,0-1.977H30.825a.988.988,0,0,0,0,1.977Zm0,7.907H46.639a.988.988,0,1,0,0-1.977H30.825a.988.988,0,1,0,0,1.977Zm0,7.907H46.639a.988.988,0,1,0,0-1.977H30.825a.988.988,0,1,0,0,1.977ZM16.988,36.662h29.65a.988.988,0,1,0,0-1.977H16.988a.988.988,0,1,0,0,1.977Zm29.65,7.907a.988.988,0,1,0,0-1.977H16.988a.988.988,0,1,0,0,1.977Z",
    transform: "translate(-0.07 -0.07)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonBillableProjectIconsGroup);
export default __webpack_public_path__ + "static/media/non-billable-project-icons-group.005b42ef214ce5b05ae63454a9bc64ff.svg";
export { ForwardRef as ReactComponent };